import { useMounted } from '@hooks/useMounted';
import { SyntheticEvent, useCallback, useState } from 'react';

export const useToggle = <T = boolean, F = boolean>(
    defaultState = false,
    truthy: T = true as any,
    falsy: F = false as any,
): {
    current: T | F;
    state: boolean;
    setState(state: boolean): void;
    toggle(state?: boolean);
    handleToggle(event: SyntheticEvent);
} => {
    const isMounted = useMounted();
    const [state, setState$] = useState<boolean>(defaultState);

    const setState = useCallback(
        (value: boolean) => {
            if (isMounted()) {
                setState$(value);
            }
        },
        [setState$],
    );

    const toggle = useCallback(
        (state$?: boolean) => {
            if (typeof state$ === 'boolean') {
                setState(state$);
            } else {
                setState(!state);
            }
        },
        [state, setState],
    );

    const handleToggle = useCallback(
        (event) => {
            event.preventDefault();
            event.stopPropagation();

            toggle(event.target.value);
        },
        [toggle],
    );

    return {
        current: state ? truthy : falsy,
        state,
        setState,
        toggle,
        handleToggle,
    };
};
